<template>
  <div class="flex flex-col gap-2">
    <slot name="label" v-if="$slots.label"></slot>
    <div
      class="flex"
      :class="{
        'flex-col': direction === 'vertical',
        'flex-row': direction === 'horizontal',
        'gap-4': direction === 'vertical',
        'gap-6': direction === 'horizontal',
      }"
    >
      <RadioButton
        v-for="option in options"
        :key="option.value"
        :id="`${name}-${option.value}`"
        :name="name"
        v-model="currentValue"
        :value="option.value"
        :label="option.label"
        :disabled="disabled"
        :size="size"
        :customIcon="customIcon"
      />
    </div>
  </div>
</template>

<script>
import RadioButton from './radio.vue';

export default {
  name: 'RadioGroup',
  components: { RadioButton },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      // Each option should have { label: String, value: String|Number|Boolean }
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: (value) => ['vertical', 'horizontal'].includes(value),
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
    },
    customIcon: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  computed: {
    currentValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script> 